class BaseReviewController {
	
    constructor(className, _, preFetchedData, componentRegistryService, componentDataService, disclosureService, loggerService, $state, constants, securityService, fileSaver, backPath, disclosureType, blobDownloadService) {
        this._ = _;
        this.state = $state;
        this.componentRegistryService = componentRegistryService;
        this.componentDataService = componentDataService;
        this.disclosureService = disclosureService;
        this.securityService = securityService;
        this.disclosureData = preFetchedData.disclosureData;	
        this.isViewingOwnDisclosure = this.disclosureData.discloserId == securityService.getAutheticatedUserId();
	    this.commentRequiredReturnToAssessor = () => true;
        this.commentRequiredSubmit = () => false;
        this.commentRequired = this.commentRequiredSubmit;
        this.commentRequiredWrapper = () => this.commentRequired();
        this.showIsuAssessmentView = this.disclosureData.dateIsuReviewed || (this.securityService.isAdmin() && this.disclosureData.status === 'AssessedPendingIsu');
        this.showAmend = this.isViewingOwnDisclosure && (this.disclosureData.status === 'AssessedPendingIsu' || this.disclosureData.status === 'Completed') ;       
        this.showDeactivationView = this.disclosureData.status === 'Inactive' || (this.securityService.isAdmin() && (this.disclosureData.status === 'Completed' || this.disclosureData.status === 'Archiving')); this.showPDFDownload = this.disclosureData.status === 'Completed';
        this.showPDFDownload = this.disclosureData.status === 'Completed';
        this.assignAlternativeOfficer = this.disclosureData.status === 'PendingRoAssignment' && securityService.isAdmin();
        this.isReassign = this.disclosureData.status === 'PendingAssessment' && securityService.isAdmin();
        this.showAlternativeOfficer = !this.assignAlternativeOfficer && (!this.isReassign || (this.disclosureData.lineManagerId && !this.disclosureData.alternativeOfficerId));
        this.showReassign =  !this.showAlternativeOfficer || this.isReassign;
        this.fileSaver = fileSaver;
        this.backPath = backPath;
        this.disclosureType = disclosureType;
        this.loggerService = loggerService;
        this.className = className;
        this._handleError = (error) => loggerService.logError("An error occured. Please try again later.", error, this.className, true);
        this.componentDataService.setDto(preFetchedData);
        this.blobDownloadService = blobDownloadService;        
        this.reviewConfirmation = this.disclosureData.status === 'Draft' || (this.disclosureData.status === 'Amending' && this.isViewingOwnDisclosure);
        this.showReviewed = this.isViewingOwnDisclosure && this.disclosureData.status === 'Completed';
        
    }    

    pdfFileName() {
        return `${this.disclosureType}-${this.disclosureData.displayId}.pdf`;
    }

    submitROAssignment() {
       
        let alternativeOfficer = this.componentRegistryService.get("alternativeOfficer");
        alternativeOfficer.validateAsync().then((isValid) => {
            if (isValid) {
                let data = {
                    AlternativeOfficerId: alternativeOfficer.model.curtinId,
                    disclosureId: this.disclosureData.id
                };

                this.disclosureService.submitRoAssignment(data).then((response) => {
                    if (this._.isEmpty(response.error)) {
                        return this.state.go("/.admin.managedisclosures");
                    } else {
                        this.loggerService.logError("An error occured. Please try again later.", response.error, this.className, true);
                        return { success: false };
                    }
                });
            }
        });
    }

  	submitIsuAssessment() {
        this.commentRequired = this.commentRequiredSubmit;
        let commentComponent = this.componentRegistryService.get("isuNotes");
        let data = {
            notes: commentComponent.model,
            disclosureId: this.disclosureData.id
        };

        this.disclosureService.submitIsuReview(data).then((response) => {
            if (this._.isEmpty(response.error)) {
                return this.state.go("/.admin.managedisclosures");
            } else if (response.error) {  
                this.loggerService.logError(response.error[0], response.error, this.className, true);
                } else {            
                    this.loggerService.logError("An error occured. Please try again later.", response.error, this.className, true);
                    return {success: false};
            }  
        });
    }
   
    returnToAssessor() {
        this.commentRequired = this.commentRequiredReturnToAssessor;
        let commentComponent = this.componentRegistryService.get("isuNotes");
        commentComponent.validateAsync().then((isValid) => {
            if (isValid) {
                let data = {
                    notes: commentComponent.model,
                    disclosureId: this.disclosureData.id
                };

                this.disclosureService.returnToAssessor(data).then((response) => {
                    if (this._.isEmpty(response.error)) {
                        return this.state.go("/.admin.managedisclosures");
                    } else {
                        this.loggerService.logError("An error occured. Please try again later.", response.error, this.className, true);
                        return {success: false};
                    }  
                });
            }
        });
    }

    deactivateDisclosure() {
        let commentComponent = this.componentRegistryService.get("deactivationNotes");
        commentComponent.validateAsync().then((isValid) => {
            if (isValid) {
                let data = {
                    notes: commentComponent.model,
                    disclosureId: this.disclosureData.id
                };

                this.disclosureService.deactiveDisclosure(data).then((response) => {
                    if (this._.isEmpty(response.error)) {
                        return this.state.go("/.admin.managedisclosures");
                    } else {
                        this.loggerService.logError("An error occured. Please try again later.", response.error, this.className, true);
                        return {success: false};
}
                });
            }
        });
    }

    back() {
        this.state.go(this.backPath, { disclosureId: this.disclosureData.id });
    }

    submit() {
        if (this.validateAll()) {
            let data = this.componentDataService.getDto(this.disclosureType);
            data.id = this.disclosureData.id;
            let disclosureId = data.id;
            this.disclosureService.saveDisclosure(data).then((saveResponse) => {
                if (this._.isEmpty(saveResponse.error)) {
                    this.disclosureService.submitDisclosure(disclosureId).then((submitResponse) => {
                        if (this._.isEmpty(submitResponse.error)) {
                            this.state.go("/.coi.disclosuresuccess", { disclosureId: disclosureId });
                        } else {
                            this._handleError(submitResponse.error);
                        }
                    });

                } else {
                    this._handleError(saveResponse.error);
                }
            });
        }
    }

    amend() {        
        let data = this.componentDataService.getDto(this.disclosureType);
        data.id = this.disclosureData.id;
        let disclosureId = data.id;
        this.disclosureService.amendDisclosure(disclosureId).then((amendResponse) => {
            if (this._.isEmpty(amendResponse.error)) {    
                if (this.disclosureType == 'Gift')                                       
                    this.state.go("/.coi.gift", { disclosureId: disclosureId });            
                else                    
                    this.state.go("/.coi.conflictofinterest", { disclosureId: disclosureId });            
            } else {
                this._handleError(amendResponse.error);
            }
        });       
    }

    reviewedDisclosure() {      
        let disclosureId = this.disclosureData.id;
        this.disclosureService.reviewedDisclosure(disclosureId).then((response) => {
            if (this._.isEmpty(response.error)) {
                this.state.go("/.coi.mydisclosures");
            } else {
                this._handleError(response.error);
            }
        });
    }

    archiveDisclosure() {
        let disclosureId = this.disclosureData.id;
        this.disclosureService.archiveDisclosure(disclosureId).then((response) => {
            if (this._.isEmpty(response.error)) {
                this.state.go("/.coi.mydisclosures");
            } else {
                this._handleError(response.error);
            }
        });
    }

    validateAll() {
        return this.componentRegistryService.getRegistered().every((comp) => comp.validate());
    }

    onFileFetched(fileDto) {       
        this.disclosureService.getFile(fileDto).then((response) => {
            this.fileSaver.saveAs(response.data, fileDto.fileName);
        });
    }

    downloadPDF() {
        let extractedHtml = angular.element("section").html();
       
        this.blobDownloadService.downloadDisclosurePDF(this.disclosureData.id, extractedHtml).then((response) => {
            if (!response.error) {
                if (response.data) {
                    this.fileSaver.saveAs(response.data, this.pdfFileName());
                }
                else {
                    this.toastr.warning("Error while downloading PDF.");
                }
            }
     });
 }
}

export default BaseReviewController;



// WEBPACK FOOTER //
// ./app/components/base-review.controller.js